import React, { useCallback, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";

import { useGetMarketerSettlements } from "../../../lib/queries/queriesAndMutations";
import Pagination from "../../Pagination";
import SettlementRow from "./cards/SettlementRow";
import SettlemtCard from "./cards/SettlemtCard";
import GenerateSettlementMarketer from "./generate_settlement_marketer";
const pageSize = 20;

const MaketerSettlements = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isPending } = useGetMarketerSettlements({
    currentPage,
    pageSize,
  });

  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  if (isPending) {
    return (
      <div className="w-full h-full flex-center">
        <PageSkeletonLoader />
      </div>
    );
  }
  return (
    <div className="w-full p-1 md:p-2 h-full flex flex-col  overflow-hidden ">
      {/* <div className="w-full flex justify-end items-center mb-2 ">
        <GenerateSettlementMarketer />
      </div> */}

      <div className="hidden lg:block h-full w-fit overflow-auto rounded-xl border border-neutral-200 bg-white shadow-sm  max-w-[60vw] lg:max-w-[70vw] mx-auto">
        <table className="overflow-scroll">
          <thead className="bg-neutral-20">
            <tr className="h-14">
              <th className="px-6 text-center text-sm font-semibold text-neutral-700">مبلغ تسویه (ریال)</th>
              <th className="px-6 text-center text-sm font-semibold text-neutral-700">وضعیت تسویه</th>
              <th className="px-6 text-center text-sm font-semibold text-neutral-700">تاریخ ایجاد</th>
              <th className="px-6 text-center text-sm font-semibold text-neutral-700 min-w-32">
                تاریخ پرداخت
              </th>
              <th className="px-6 text-center text-sm font-semibold text-neutral-700">نام صاحب حساب</th>
              <th className="px-6 text-center text-sm font-semibold text-neutral-700">شماره شبا</th>
              <th className="px-6 text-center text-sm font-semibold text-neutral-700">کدرهگیری بانکی</th>
            </tr>
          </thead>

          <tbody>
            {data?.data?.items?.length ? (
              data.data.items.map((item, index) => (
                <SettlementRow key={item.id ?? index} rowData={item} index={index} />
              ))
            ) : (
              <tr>
                <td colSpan={4} className="py-10 text-center text-neutral-500">
                  آیتمی وجود ندارد...
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="w-full bg-neutral-10 p-2 grid grid-cols-1  lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 gap-4 md:p-2 rounded-[16px]  lg:hidden  overflow-y-auto  ">
        {data?.data?.items.length > 0 ? (
          data?.data?.items.map((item, index) => <SettlemtCard key={index} item={item} navigate={navigate} />)
        ) : (
          <p>آیتمی وجود ندارد ...</p>
        )}
      </div>
      <div className="w-full bg-neutral-10 rounded-v-lg  ">
        <Pagination
          onPageChange={onPageChange}
          totalCount={data?.data?.count}
          siblingCount={1}
          currentPage={currentPage}
          pageSize={pageSize}
          className="bg-primary-40"
        />
      </div>
    </div>
  );
};

export default MaketerSettlements;

const PageSkeletonLoader = () => {
  const array = new Array(20).fill(null).map((u, i) => i);

  return (
    <div className="my-8 p-1 md:p-2 h-full flex flex-col  overflow-hidden  gap-2 w-fit mx-auto">
      {array.map((_, i) => {
        return (
          <div key={i} className="w-[70vw] h-10 ">
            <Skeleton className="h-full" />
          </div>
        );
      })}
    </div>
  );
};
